module.exports = __webpack_public_path__ + "static/img/massage_img1.0bf3b21a.png";